var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dim-layer", on: { keydown: _vm.keymap } }, [
    _c("div", { staticClass: "set-box" }, [
      _c(
        "div",
        { staticClass: "inner-box", attrs: { disabled: "" } },
        [
          _c(
            "div",
            { staticClass: "inp-wrapper" },
            [
              _c(
                "div",
                { staticClass: "header" },
                [
                  _c("GrmBackBtn", {
                    staticClass: "back-btn",
                    on: { click: _vm.back },
                  }),
                  _c("p", { staticClass: "inp-title" }, [
                    _vm._v(_vm._s(_vm.$t("guest.name"))),
                  ]),
                ],
                1
              ),
              _c("GrmInput", {
                ref: "nickname",
                attrs: {
                  minlength: 2,
                  maxlength: 25,
                  placeholder: _vm.nicknamePlaceholder,
                  checkList: _vm.nicknameCheckList,
                },
                model: {
                  value: _vm.nickname,
                  callback: function ($$v) {
                    _vm.nickname = $$v
                  },
                  expression: "nickname",
                },
              }),
            ],
            1
          ),
          _c(
            "GrmBtn",
            {
              staticClass: "btn-login w-full",
              attrs: { disabled: _vm.disabledGuestLogin },
              on: { click: _vm.handleGuestLogin },
            },
            [_vm._v(_vm._s(_vm.$t("guest.join")))]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }